import {
  LadySliderModalMedia,
  LadySliderModalMediaIntroVideo,
  LadySliderModalMediaPhoto,
  LadySliderModalMediaVideo,
} from "@/components/modal/models";

const isIntroVideo = (
  mediaObject: LadySliderModalMedia[number],
): mediaObject is LadySliderModalMediaIntroVideo & {
  type: "intro_video";
} => {
  return mediaObject.type === "intro_video";
};
const isVideo = (
  mediaObject: LadySliderModalMedia[number],
): mediaObject is LadySliderModalMediaVideo => {
  return LadySliderModalMediaVideo.safeParse(mediaObject).success;
};

const isAnyVideo = (
  mediaObject: LadySliderModalMedia[number],
): mediaObject is
  | LadySliderModalMediaIntroVideo
  | LadySliderModalMediaVideo => {
  return (
    LadySliderModalMediaIntroVideo.safeParse(mediaObject).success ||
    LadySliderModalMediaVideo.safeParse(mediaObject).success
  );
};

const isLadyPhoto = (
  mediaObject: LadySliderModalMedia[number],
): mediaObject is LadySliderModalMediaPhoto & {
  type: "photo";
} => {
  return mediaObject.type === "photo";
};

export const helper = { isIntroVideo, isVideo, isAnyVideo, isLadyPhoto };
